import { render, staticRenderFns } from "./ProcessChargesShipmentsGrid.vue?vue&type=template&id=6dcfc095&scoped=true&"
import script from "./ProcessChargesShipmentsGrid.vue?vue&type=script&lang=js&"
export * from "./ProcessChargesShipmentsGrid.vue?vue&type=script&lang=js&"
import style0 from "./ProcessChargesShipmentsGrid.vue?vue&type=style&index=0&id=6dcfc095&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcfc095",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dcfc095')) {
      api.createRecord('6dcfc095', component.options)
    } else {
      api.reload('6dcfc095', component.options)
    }
    module.hot.accept("./ProcessChargesShipmentsGrid.vue?vue&type=template&id=6dcfc095&scoped=true&", function () {
      api.rerender('6dcfc095', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ProcessChargesShipments/ProcessChargesShipmentsGrid.vue"
export default component.exports